module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_calendar_remoteEntry_mjs_30f81530__;